var $312afa7e9128739a$exports = {};
(()=>{
    const refs = {
        openMenuBtn: document.querySelector('[data-menu-open]'),
        closeMenuBtn: document.querySelector('[data-menu-close]'),
        menu: document.querySelector('[data-menu]'),
        body: document.querySelector('#page')
    };
    refs.openMenuBtn.addEventListener('click', toggleModal);
    refs.closeMenuBtn.addEventListener('click', toggleModal);
    function toggleModal() {
        refs.menu.classList.toggle('is-open');
        refs.body.classList.toggle('no-scroll');
    }
})();


//# sourceMappingURL=foodsta.7a1ac486.js.map
